import React, { useMemo } from 'react';

import { Chip } from '@column/column-ui-kit';

import { getTransferDirectionIcon, getTransferDirectionLabel } from '../direction';
import { TransferEntryType } from '~/repositories';

export const TransferDirectionChip = ({
  transferType,
  isIncoming,
}: {
  transferType: TransferEntryType;
  isIncoming: boolean;
}) => {
  const icon = useMemo(() => getTransferDirectionIcon(transferType, isIncoming), [transferType, isIncoming]);
  const label = useMemo(() => getTransferDirectionLabel(transferType, isIncoming), [transferType, isIncoming]);
  return (
    <Chip variant="subtle" icon={icon}>
      {label}
    </Chip>
  );
};
